import { classNames } from '@dimjs/utils';
import { IphoneBottomAdaptive } from '../../iphone-bottom-adaptive';
import { CommonPropsWithChildren } from '../../utils';

export type FooterProps = CommonPropsWithChildren & {
  iphoneBottomAdaptive?: boolean;
};
export const Footer = (props: FooterProps) => {
  return (
    <div className={classNames('v-footer', props.className)} style={props.style}>
      {props.children}
      {props.iphoneBottomAdaptive && <IphoneBottomAdaptive />}
    </div>
  );
};
